import { Collapse, List, ListItemButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SidebarItem from "./SidebarItem";

type Props = {
  item: any,
};

const SidebarItemCollapse = ({ item }: Props) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (item?.child) {
      if (item?.child?.some((c: any) => location.pathname.startsWith(c?.path))) {
        setOpen(true);
      }
    }
    else {
      if (location.pathname.startsWith(item?.path)) {
        setOpen(true);
      }
    }
  }, [location, item]);

  return (
    item.sidebarProps ? (
      <>
        <ListItemButton
          onClick={() => setOpen(!open)}
          className="w-full flex p-[10px] items-center gap-2.5"
          sx={{
            "&: hover": {
              backgroundColor: "#005CA6",
              color: "#ffffff"
            },
            backgroundColor: "unset",
            padding: "10px",
          }}
        >
          <span className={`material-symbols-outlined text-inherit  text-[25px] font-extralight`}>
            {item.sidebarProps.icon && item.sidebarProps.icon}
          </span>
          <span className={`text-inherit  text-[13px] font-medium tracking-wide whitespace-normal`}>
            {item.sidebarProps.displayText}
          </span>
          {open ? <span className={`material-symbols-outlined text-inherit ml-auto text-[30px] font-extralight`}>
            arrow_drop_up
          </span> :
            <span className={`material-symbols-outlined text-inherit ml-auto text-[30px] font-extralight`}>
              arrow_drop_down
            </span>}
        </ListItemButton>


        <Collapse className="w-full" in={open} timeout="auto">
          <List className="w-full">
            {item.child?.map((route: any, index: number) => (
              route.sidebarProps &&
                route.child ? (
                <SidebarItemCollapse item={route} key={index} />
              ) : (
                <SidebarItem item={route} key={index} />
              )
            ))}
          </List>
        </Collapse>
      </>
    ) : null
  );
};

export default SidebarItemCollapse;